//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
import "../no/SelectFaceList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AnalysisType",1,0],[0,"AngleTolerance",1,0],[0,"DistanceTolerance",1,0],[1,"FacesToAnalyze",0,"SelectFaceList",0],[0,"MaximumAngle",1,0],[0,"MaximumLevel",1,0],[0,"MaximumRadius",1,0],[0,"MinimumAngle",1,0],[0,"MinimumLevel",1,0],[0,"MinimumRadius",1,0],[0,"RadiusTolerance",1,0],[0,"ReferencePlane",1,"Plane",0],[0,"ReferenceVector",1,"Direction",0],[0,"SaveFaceColors",1,0]],[[[],"Information",{},0,0],[[],"AnalyzeGeometry",{},0,0],[["count","analyzedFaces","doubleValue"],"GetResults",{R_:{success:''}},0,0]],[]];
SPLM.CAM.NCAssistantBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.NCAssistantBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.NCAssistantBuilder.AnalysisTypes = Object.freeze({
    "Levels" : "Levels", "Corners" : "Corners", "Blends" : "Blends", "Draft" : "Draft"});

export default SPLM;